import { serverSideTranslations } from 'next-i18next/serverSideTranslations';
import RightContent from 'app/components/layouts/MenuRight/RightContent';
import FontAwesomeIcon from "app/components/layouts/Icons/FontAwesome";
import { faCheckCircle } from "@fortawesome/free-solid-svg-icons";
import { withGlobalData } from 'app/utils/withGlobalData';
import * as grammarApi from 'app/requests/grammars';
import Image from 'app/components/layouts/Image';
import Title from 'app/components/layouts/Title';
import { useTranslation } from 'next-i18next';
import { Translate } from 'types/commons';
import { useRouter } from "next/router";
import { NextSeo } from 'next-seo';
import { Blog } from 'types/blog';
import Link from 'next/link';
import 'app/components/blogs/styles.css'

export default function Index({ grammars }) {
  const { t } = useTranslation();
  const router = useRouter();
  const code = router?.locale ?? 'vi';
  const contents = [
    { label: t('grammar.tenses_english'), type: 'tense' },
    { label: t('grammar.type_word'), type: 'type_word' },
    { label: t('grammar.verbs'), type: 'verb' },
    { label: t('grammar.type_sentence'), type: 'sentence' },
    { label: t('grammar.case_other'), type: 'other' },
  ]

  const getGrammar = (type: string) => {
    const list = grammars.filter((item: Blog) => item?.grammar_type?.type == type);

    return list.map((grammar: Blog) => {
      const item = grammars.find((item: Blog) => item.id == grammar.id);
      const title = item.translates.find((translate: Translate) => translate.type == 'title');
      const slug = item[`slug_${code}`];

      return (
        <Link className="link p-1" key={item.id} href={`/grammar/${slug}`}>
          <p className='text-truncate-3'>
            <Image src={`/images/grammar/${grammar?.grammar_type?.icon}`} alt="" />
            <span className='text-info'>{title[code]}</span>
          </p>
        </Link>
      )
    })
  }

  const getLengthGrammar = (type: string) => {
    const list = grammars.filter((item: Blog) => item?.grammar_type?.type == type);

    return list.length;
  }

  return (
    <section id="list_grammar" className="box-card-area">
      <NextSeo title={t('grammar.new_title')} description={t('grammar.description')} />
      <div className="container-md">
        <div className="d-flex">
          <div className="box-news-area">
            <div className='content_inner'>
              <Title title="grammar.title" />
              <div className="mt-4">
                <div className="content">
                  {contents.map((content) => {
                    return (
                      <div key={content.type} className="form-group">
                        <h2 className="text-info text-size-2xl mt-4">
                          {content.label}&nbsp;
                          <span>{getLengthGrammar(content.type)}</span>
                        </h2>
                        <div className="d-flex justify-content-center flex-wrap">{getGrammar(content.type)}</div>
                      </div>
                    )
                  })}
                </div>
              </div>
            </div>
          </div>
          <RightContent />
        </div>
      </div>
    </section>
  )
}

export const getServerSideProps = withGlobalData(async ({ locale }) => {
  try {
    const [grammars, translations] = await Promise.all([
      grammarApi.getGrammars({ code: locale }),
      serverSideTranslations(locale, ['common']),
    ]);

    return {
      props: {
        ...translations,
        grammars: grammars || [],
      },
    };
  } catch (error) {
    console.error('Error in getServerSideProps:', error);
    return { notFound: true };
  }
});
